export default __webpack_public_path__ + "static/media/top2 1.85ff3975.png";